require('../../shared/highcharts-config')

const Perf_chart = require('./pr20-perf-chart'),
  data = [
    {
      name: "Défensif 1",
      composition: "52% \u20ac<br> 48% UC",
      y: 0.33,
      vol: 2.59
    },
    {
      name: "Défensif 2",
      composition: "48% \u20ac<br> 52% UC",
      y: 0.52,
      vol: 3.26
    },
    {
      name: "Équilibré 1",
      composition: '43% \u20ac<br> 57% UC',
      y: 0.69,
      vol: 4.10
    },
    {
      name: "Équilibré 2",
      composition: '38% \u20ac<br> 62% UC',
      y: 0.71,
      vol: 4.41
    },
    {
      name: "Équilibré 3",
      composition: '31% \u20ac<br> 69% UC',
      y: 0.94,
      vol: 5.42
    },
    {
      name: "Offensif 1",
      composition: '27% \u20ac<br> 73% UC',
      y: 0.96,
      vol: 7.27
    },
    {
      name: "Offensif 2",
      composition: '23% \u20ac<br> 77% UC',
      y: 1.20,
      vol: 8.32
    },
    {
      name: "Offensif 3",
      composition: '20% \u20ac<br> 80% UC',
      y: 1.27,
      vol: 9.35
    },
    {
      name: "Agressif 1",
      composition: '17% \u20ac<br> 83% UC',
      y: 1.20,
      vol: 10.13
    },
    {
      name: "Agressif 2",
      composition: '7% \u20ac<br> 93% UC',
      y: 1.02,
      vol: 11.79
    }
  ],
  categories = $.map(data, function (d) {
    return d.composition
  })

$(function() {
  Perf_chart(data, categories)
})
